import { useEffect } from 'react';
import { Typography } from '@/lib/typography';

export default function ComingSoon({ moduleName }) {
  useEffect(() => {
    // Analytics Placeholder
    console.log('module_viewed', { module: moduleName.toLowerCase().replace(/\s+/g, '_') }); // # nolint
  }, [moduleName]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-canvas-base">
      <div className="text-center">
        <h1 className={Typography.h1}>
          {moduleName}
        </h1>
        <p className="text-slate-500">
          Coming soon
        </p>
      </div>
    </div>
  );
}
